/**
 * Links of Interest Data Configuration
 * 
 * External links to important resources and IASD websites.
 * Each link is represented by an icon/logo image.
 * 
 * Note: Titles and descriptions are managed in translation files (es.js, pt.js)
 * under links.items[id].title and links.items[id].description
 */

// Import link icon images
import iasdIcon from './icons/link-01-iasd.png';
import materialesIasdIcon from './icons/link-02-materiales-iasd.png';
import feliz7playIcon from './icons/link-03-feliz7play.png';
import semeIcon from './icons/link-04-7me.png';
import recursosBiblicosIcon from './icons/link-05-recursos-biblicos.png';
import leccionJovenesIcon from './icons/link-06-leccion-jovenes.png';
import meditacionesIcon from './icons/link-07-meditaciones.png';
import jaIcon from './icons/link-08-ja.png';
import conquistadoresIcon from './icons/link-09-conquistadores.png';
import videosIasdIcon from './icons/link-10-videos-iasd.png';
import noticiasIcon from './icons/link-11-noticias.png';
import probadVedIcon from './icons/link-12-probad-ved.png';
import accionJovenIcon from './icons/link-13-accion-joven.png';
import galeriaIcon from './icons/link-14-galeria.png';
import sabadoIcon from './icons/link-15-sabado.png';
import ministerioNinoIcon from './icons/link-16-ministerio-nino.png';
import radioNtIcon from './icons/link-17-radio-nt.png';
import whatsappIcon from './icons/link-18-whatsapp.png';

export const enlaces = [
  // ===== INSTITUCIONAL IASD =====
  { id: 'iasd', icon: iasdIcon, url: 'https://www.adventistas.org/es/' },
  { id: 'noticias-iasd', icon: noticiasIcon, url: 'https://noticias.adventistas.org/es/' },
  { id: 'whatsapp-uu', icon: whatsappIcon, url: 'https://whatsapp.com/channel/0029Vb5JWjQJUM2SF52ERq3a' },

  // ===== MULTIMEDIA Y CONTENIDO DIGITAL =====
  { id: 'feliz7play', icon: feliz7playIcon, url: 'https://feliz7play.com/es' },
  { id: 'videos-iasd', icon: videosIasdIcon, url: 'https://www.youtube.com/@adventistassudamerica' },
  { id: 'radio-nt', icon: radioNtIcon, url: 'https://www.nuevotiempo.org/en-vivo-radio-uruguay/' },

  // ===== RECURSOS Y MATERIALES DESCARGABLES =====
  { id: 'materiales-iasd', icon: materialesIasdIcon, url: 'https://downloads.adventistas.org/es/' },
  { id: 'para-el-sabado', icon: sabadoIcon, url: 'https://www.adventistas.org/es/paraelsabado/' },
  { id: 'galeria-imagenes', icon: galeriaIcon, url: 'https://www.lingoapp.com/31769/s/Bienvenido-o1A5gq?v=0' },

  // ===== JÓVENES Y JA =====
  { id: 'leccion-jovenes', icon: leccionJovenesIcon, url: 'https://www.recursos-biblicos.com/2014/04/leccion-juveniles-2do-segundo-trimestre-2014.html' },
  { id: 'ja-materiales', icon: jaIcon, url: 'https://www.adventistas.org/es/jovenes/' },
  { id: 'accion-joven', icon: accionJovenIcon, url: 'https://downloads.adventistas.org/es/ministerio-joven/revistas/accion-joven-2025/' },

  // ===== NIÑOS Y CONQUISTADORES =====
  { id: 'conquistadores', icon: conquistadoresIcon, url: 'https://www.adventistas.org/es/conquistadores/' },
  { id: 'ministerio-nino', icon: ministerioNinoIcon, url: 'https://downloads.adventistas.org/es/departamento/ministerio-del-nino/' },

  // ===== ESTUDIO BÍBLICO =====
  { id: 'recursos-biblicos', icon: recursosBiblicosIcon, url: 'https://www.recursos-biblicos.com/' },

  // ===== MAYORDOMÍA Y PROYECTOS =====
  { id: 'meditaciones-2025', icon: meditacionesIcon, url: 'https://www.adventistas.org/es/mayordomiacristiana/proyecto/meditaciones-para-la-puesta-del-sol-2025/' },
  { id: '7me', icon: semeIcon, url: 'https://home.7me.app/esp/' },
  { id: 'probad-ved', icon: probadVedIcon, url: 'https://www.adventistas.org/es/mayordomiacristiana/categoria_do_video/probad-y-ved/' },
];

export default enlaces;

